import { render, staticRenderFns } from "./ClockMap.vue?vue&type=template&id=b489550a&scoped=true&"
import script from "./ClockMap.vue?vue&type=script&lang=js&"
export * from "./ClockMap.vue?vue&type=script&lang=js&"
import style0 from "./ClockMap.vue?vue&type=style&index=0&id=b489550a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b489550a",
  null
  
)

export default component.exports